/** Bölüm başlığı: küçük üst etiket, başlık, isteğe bağlı açıklama. */
export default function SectionHeading({ eyebrow, title, children, center = false }) {
  return (
    <div className={`space-y-3 ${center ? "text-center mx-auto" : ""} max-w-2xl`}>
      {eyebrow ? (
        <p className="text-xs uppercase tracking-[0.22em] text-terakkiPrimaryDark/70">{eyebrow}</p>
      ) : null}
      <h2 className="text-3xl md:text-4xl font-SemiBold leading-tight text-terakkiInk">{title}</h2>
      {children ? <p className="text-terakkiInk/70 leading-relaxed">{children}</p> : null}
    </div>
  );
}
